import { useParams } from '@cedarjs/router'

import { useMyOrg, useOrganizationByPath } from '../layouts/AppStateContextLayout/utils'
import { useRecordContext } from '../pages/RecordPage/Record/Context'

export const useSlug = () => {
  const { slug } = useParams()
  const orgSlugMetadata = useOrganizationByPath()
  const myOrg = useMyOrg()
  const recordContext = useRecordContext()
  return slug || recordContext?.orgSlug || orgSlugMetadata?.slug || myOrg?.slug || ''
}
